import BaseUI from "../base-ui.ts";
import State from "../../state/state.ts";
import EatOutApiClient from "../../api-client/eat-out-api-client.ts";
import Route from "../../enums/route.ts";
import CACHE_BUSTER from "../../../../../cache-buster.json" with { type: "json" };

export default class LogoFragment extends BaseUI {
  constructor(state: State, apiClient: EatOutApiClient, navigateCallback: (route: Route) => void) {
    super("eat-out-logo-fragment", state, apiClient, navigateCallback);
  }

  public override render(newElements: HTMLElement[] = []): HTMLDivElement {
    const picture: HTMLPictureElement = document.createElement("picture");
    const img: HTMLImageElement = document.createElement("img");
    img.src = CACHE_BUSTER["static/image/social/logo.webp"];
    img.alt = "Eat Out Logo";
    picture.appendChild(img);
    newElements.push(picture);

    return super.render(newElements);
  }
}
